import Carousel from 'react-material-ui-carousel';
import {
    Stack,
    Typography,
    Container,
    Button,
    Box,
    MenuItem,
    FormControl,
    InputLabel, IconButton,
} from '@mui/material';
import axios from "../../axios";
import axiosRetry from 'axios-retry';
import {Fragment, useState,useEffect} from "react";
import {Map, InstitutionCard, TestimonyCard, CardBlock, ImageTextBlock} from "../index";
import { getGeocode, getLatLng} from "use-places-autocomplete";
import SearchIcon from '@mui/icons-material/Search';
import GroupIcon from '@mui/icons-material/Group';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import {useNavigate} from "react-router-dom";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import {useDarkMode} from "../darkMode/hook/useDarkMode";
import * as React from "react";
import {usePoliceMode} from "../policeMode/hook/usePoliceMode";
import Select from 'react-select';

const EstablishmentList = () => {
    const [institutions, setInstitutions] = useState([]);
    const [filteredInstitutions, setFilteredInstitutions] = useState([]);
    const [publics, setPublics] = useState([]);
    const [specificities, setSpecificities] = useState([]);
    const [publicType, setPublicType] = useState('');
    const [specificity, setSpecificity] = useState('');
    const [markers, setMarkers] =  useState([]);
    const [anchor, setAnchor] = useState(1);
    const [showMoveUpButton, setShowMoveUpButton] = useState(false);
    const [showMoveDownButton, setShowMoveDownButton] = useState(true);
    const {mode} = useDarkMode();
    const {police} = usePoliceMode();

    axiosRetry(axios, { retries: 3 });
    const navigate = useNavigate();

    useEffect(() => {
        axios.get(`${axios.defaults.apiURL}/institutions`
        ).then(function (response) {
            setInstitutions(response.data);
            setFilteredInstitutions(response.data);
            response.data.forEach((institution) => {
                populateMarkers(institution)
            })

        }).catch(function (error) {
            if (error.response) {
                console.log('Error', error.message);
            }
        });

        axios.get(`${axios.defaults.apiURL}/publics`
        ).then(function (response) {
            setPublics(response.data.map((item) => {return {value : item.id, label : item.label.text}}));
        }).catch(function (error) {
            console.log('Error', error.message);
        });

        axios.get(`${axios.defaults.apiURL}/specificities`
        ).then(function (response) {
            setSpecificities(response.data.map((item) => {return {value : item.id, label : item.name.text}}));
        }).catch(function (error) {
            console.log('Error', error.message);
        });

        return () => {
            setInstitutions([]);
            setFilteredInstitutions([]);
            setPublics([]);
            setSpecificities([]);
            setMarkers([]);
        };
    }, []);

    const handlePublicChange = (value) => {
        setPublicType(value);
    };

    const handleSpecificityChange = (value) => {
        console.log('it', value)
        setSpecificity(value);
    };

    const handleSubmit = () => {
        console.log('specificity', specificity);
        console.log('public', publicType);
        setFilteredInstitutions([]);
        setMarkers([]);
        institutions.forEach((institution) => {
            if (
                institution.relations.specificity.some(s => s.name.text === specificity.label)
                &&
                institution.relations.public.some(p => p.label.text === publicType.label)
            ){
                setFilteredInstitutions(current => [...current, institution])
                populateMarkers(institution)
            }
        })
    }

    const handleReset = () => {
        setPublicType('');
        setSpecificity('');
        setFilteredInstitutions(institutions)
        institutions.forEach((institution) => {
            populateMarkers(institution)
        })
    }

    const populateMarkers = (institution) => {
        getGeocode({address: institution.road.text+" "+institution.zipcode.text+" "+institution.city.text})
            .then((results) => getLatLng(results[0]))
            .then(({ lat, lng }) => {
                setMarkers(current => [...current, {position:{lat, lng}, name:institution.name.text }]);
            })
            .catch((error) => {
                console.log("Error: ", error);
            });
    }

    return (

            <div className={'wrap-container'} id={'anchor1'}>
                <Stack id={'anchor2'} style={{display : 'flex', flexDirection : 'column', alignItems : 'center'}}>
                    <Typography variant="h2"
                        style={{color : mode.settings.textColor3}}
                        sx={{
                            textAlign : {xs : 'center' , md : 'center', lg : 'left'},
                            marginTop : '15px'
                        }}
                    > Je recherche un établissement </Typography>
                    <div style={{display: 'flex', justifyContent: 'center', marginBottom:12, marginTop: 12, flexWrap : 'wrap', gap : 10}}>
                        <Select
                            value={publicType}
                            onChange={handlePublicChange}
                            options={publics}
                            placeholder={'Public'}
                            styles={{
                                control: (baseStyles, state) => ({
                                    ...baseStyles,
                                    backgroundColor : mode.settings.cardBackgroundColor,
                                    width : '296px',
                                    height : '44px',
                                    fontFamily: police.normalMode ? 'Roboto' : 'dyslexic'
                                }),
                                placeholder: (defaultStyles) => {
                                    return {
                                        ...defaultStyles,
                                        color: mode.settings.textColor3,
                                        fontSize: '14px',
                                        fontFamily: police.normalMode ? 'Roboto' : 'dyslexic'
                                    }
                                },
                                singleValue: (styles, { data, isDisabled, isFocused, isSelected }) => {
                                    return {
                                        ...styles,
                                        color: mode.settings.textColor3,
                                        fontFamily: police.normalMode ? 'Roboto' : 'dyslexic'
                                    };
                                },
                                option: (defaultStyles) => {
                                    return {
                                        ...defaultStyles,
                                        color: mode.settings.textColor3,
                                        fontSize: '14px',
                                        fontFamily: police.normalMode ? 'Roboto' : 'dyslexic',
                                        backgroundColor : mode.settings.cardBackgroundColor,
                                    }
                                },
                            }}
                        />
                        <Select
                            value={specificity}
                            onChange={handleSpecificityChange}
                            options={specificities}
                            placeholder={'Type d\'accompagnement'}
                            styles={{
                                control: (baseStyles, state) => ({
                                    ...baseStyles,
                                    backgroundColor : mode.settings.cardBackgroundColor,
                                    width : '296px',
                                    height : '44px',
                                    fontFamily: police.normalMode ? 'Roboto' : 'dyslexic'
                                }),
                                placeholder: (defaultStyles) => {
                                    return {
                                        ...defaultStyles,
                                        color: mode.settings.textColor3,
                                        fontSize: '14px',
                                        fontFamily: police.normalMode ? 'Roboto' : 'dyslexic'
                                    }
                                },
                                singleValue: (styles, { data, isDisabled, isFocused, isSelected }) => {
                                    return {
                                        ...styles,
                                        color: mode.settings.textColor3,
                                        fontFamily: police.normalMode ? 'Roboto' : 'dyslexic'
                                    };
                                },
                                option: (defaultStyles) => {
                                    return {
                                        ...defaultStyles,
                                        color: mode.settings.textColor3,
                                        fontSize: '14px',
                                        fontFamily: police.normalMode ? 'Roboto' : 'dyslexic',
                                        backgroundColor : mode.settings.cardBackgroundColor,
                                    }
                                },
                            }}
                        />
                        {/*<FormControl sx={{mr:1, minWidth:200}} size="small">*/}
                        {/*    <InputLabel*/}
                        {/*        id="public-select-label"*/}
                        {/*        style={{color : mode.settings.textColor3}}*/}
                        {/*    >*/}
                        {/*        Type*/}
                        {/*    </InputLabel>*/}
                        {/*    <Select*/}
                        {/*        value={publicType}*/}
                        {/*        id="public-select"*/}
                        {/*        labelId="public-select-label"*/}
                        {/*        autoWidth={true}*/}
                        {/*        onChange={handlePublicChange}*/}
                        {/*        MenuProps={{*/}
                        {/*            PaperProps: {*/}
                        {/*                style: {*/}
                        {/*                    backgroundColor: mode.darkMode ? '#242526' : 'white',*/}
                        {/*                    color: mode.settings.textColor3,*/}
                        {/*                },*/}
                        {/*            },*/}
                        {/*        }}*/}
                        {/*        defaultValue=""*/}
                        {/*        style={{height:'49px',backgroundColor : mode.settings.card3BackgroundColor, color : mode.settings.textColor3}}*/}
                        {/*    >*/}
                        {/*        {publics.map((option,index) => (*/}
                        {/*            <MenuItem key={index} value={option.label.text}>*/}
                        {/*                {option.label.text}*/}
                        {/*            </MenuItem>*/}
                        {/*        ))}*/}
                        {/*    </Select>*/}
                        {/*</FormControl>*/}

                        {/*<FormControl sx={{mr:1, minWidth:200}} size="small">*/}
                        {/*    <InputLabel id="specificity-select-label" style={{color : mode.settings.textColor3}}>Spécificité</InputLabel>*/}
                        {/*    <Select*/}
                        {/*        value={specificity}*/}
                        {/*        id="specificity-select"*/}
                        {/*        labelId="specificity-select-label"*/}
                        {/*        autoWidth={true}*/}
                        {/*        onChange={handleSpecificityChange}*/}
                        {/*        MenuProps={{*/}
                        {/*            PaperProps: {*/}
                        {/*                style: {*/}
                        {/*                    backgroundColor: mode.darkMode ? '#242526' : 'white',*/}
                        {/*                    color: mode.settings.textColor3,*/}
                        {/*                },*/}
                        {/*            },*/}
                        {/*        }}*/}
                        {/*        defaultValue=""*/}
                        {/*        style={{height:'49px',backgroundColor : mode.settings.card3BackgroundColor, color : mode.settings.textColor3}}*/}
                        {/*    >*/}
                        {/*        {specificities.map((option, index) => (*/}
                        {/*            <MenuItem key={index} value={option.name.text}>*/}
                        {/*                {option.name.text}*/}
                        {/*            </MenuItem>*/}
                        {/*        ))}*/}
                        {/*    </Select>*/}
                        {/*</FormControl>*/}
                        <FormControl size="small">
                            <Button
                                className={'btn-gradient'}
                                variant="contained"
                                onClick={handleSubmit}
                                startIcon={<SearchIcon role="img" aria-label="Chercher"/>}
                            >
                                <Typography variant={'subtitle3'}>Chercher</Typography>
                            </Button>
                        </FormControl>
                    </div>
                    <Typography component="a" onClick={handleReset} className={'link text-gradient'} sx={{mt:1}}>
                        Réinitialiser les filtres
                    </Typography>
                    <Stack spacing={2} gap={'33px'} flexDirection={'row'} flexWrap={'wrap'}
                           sx={{justifyContent:
                                   {xs :'center' , md :'center', lg :'flex-start'},
                                    alignItems : 'flex-end', marginTop : '10px'
                                }}
                    >
                        {filteredInstitutions.map((institution,index) => (
                            <InstitutionCard institution={institution} key={index} />
                        ))}
                    </Stack>
                </Stack>
                <div style={{marginTop : '50px'}}><Map markers={markers} /></div>
            </div>

    )
}

export default EstablishmentList;
